{
    "definitions": {
        "RequiredAttributes": {
            "type": "object",
            "properties": {},
            "additionalProperties": {
                "oneOf": [
                    {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    {
                        "type": "string"
                    }
                ]
            }
        },
        "AnyAttributes": {
            "type": "object",
            "properties": {},
            "additionalProperties": {
                "oneOf": [
                    {
                        "type": "array",
                        "items": {
                            "type": "string"
                        }
                    },
                    {
                        "type": "string"
                    }
                ]
            }
        },
        "FilterAutocomplete": {
            "type": "object",
            "properties": {
                "values": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "properties": {
                            "value": {
                                "type": "string"
                            },
                            "label": {
                                "type": "string"
                            }
                        },
                        "required": ["value"]
                    }
                },
                "fetch_from_warehouse": {
                    "type": "boolean"
                },
                "label_dimension": {
                    "type": "string",
                    "description": "Name of another dimension in the same table whose value is shown as the display label for each warehouse-fetched value."
                }
            }
        },
        "DefaultTimeDimension": {
            "type": "object",
            "properties": {
                "field": {
                    "type": "string",
                    "minLength": 1
                },
                "interval": {
                    "type": "string",
                    "enum": ["DAY", "WEEK", "MONTH", "YEAR"]
                }
            },
            "required": ["field", "interval"]
        },
        "Compact": {
            "type": "string",
            "enum": [
                "auto",
                "thousands",
                "millions",
                "billions",
                "trillions",
                "thousand",
                "million",
                "billion",
                "trillion",
                "K",
                "M",
                "B",
                "T",
                "kilobytes",
                "megabytes",
                "gigabytes",
                "terabytes",
                "petabytes",
                "kilobyte",
                "megabyte",
                "gigabyte",
                "terabyte",
                "petabyte",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "kibibytes",
                "mebibytes",
                "gibibytes",
                "tebibytes",
                "pebibytes",
                "kibibyte",
                "mebibyte",
                "gibibyte",
                "tebibyte",
                "pebibyte",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB"
            ]
        },
        "Format": {
            "type": "string"
        },
        "Separator": {
            "type": "string",
            "enum": [
                "default",
                "commaPeriod",
                "spacePeriod",
                "periodComma",
                "noSeparatorPeriod",
                "apostrophePeriod"
            ]
        },
        "Urls": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "url": {
                        "type": "string",
                        "description": "Liquidjs template for the URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}"
                    },
                    "label": {
                        "type": "string"
                    }
                }
            }
        },
        "Image": {
            "type": "object",
            "description": "Displays the dimension value as an image",
            "properties": {
                "url": {
                    "type": "string",
                    "description": "Liquidjs template for the image URL. Available variables: ${value.raw}, ${value.formatted}, ${row.table_name.field_name.raw}, ${row.table_name.field_name.formatted}. Only fields selected in the query are available in row context."
                },
                "width": {
                    "type": "number"
                },
                "height": {
                    "type": "number"
                },
                "fit": {
                    "type": "string"
                }
            },
            "required": ["url"]
        },
        "Tags": {
            "oneOf": [
                {
                    "type": "string"
                },
                {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                }
            ]
        },
        "LightdashDimension": {
            "type": "object",
            "required": [],
            "properties": {
                "name": {
                    "type": "string",
                    "not": { "enum": ["TABLE"] }
                },
                "label": {
                    "type": "string"
                },
                "type": {
                    "type": "string",
                    "enum": ["string", "number", "boolean", "date", "timestamp"]
                },
                "description": {
                    "type": "string"
                },
                "sql": {
                    "type": "string"
                },
                "time_intervals": {
                    "oneOf": [
                        {
                            "const": "default"
                        },
                        {
                            "type": "boolean"
                        },
                        {
                            "const": "OFF"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    ]
                },
                "convert_timezone": {
                    "type": "boolean",
                    "description": "When false, this dimension is rendered in its raw warehouse value and is not converted to the project timezone for display. Filter SQL still converts. Defaults to true."
                },
                "timestamp_domain": {
                    "type": "string",
                    "enum": ["aware", "naive"],
                    "description": "Declares whether this timestamp column stores an instant ('aware') or a bare wall clock ('naive'); overrides the warehouse catalog."
                },
                "hidden": {
                    "type": "boolean"
                },
                "round": {
                    "type": "number"
                },
                "compact": {
                    "$ref": "#/definitions/Compact"
                },
                "format": {
                    "$ref": "#/definitions/Format"
                },
                "separator": {
                    "$ref": "#/definitions/Separator"
                },
                "group_label": {
                    "type": "string",
                    "deprecated": true,
                    "description": "Deprecated: use groups instead"
                },
                "urls": {
                    "$ref": "#/definitions/Urls"
                },
                "image": {
                    "$ref": "#/definitions/Image"
                },
                "tags": {
                    "$ref": "#/definitions/Tags"
                },
                "required_attributes": {
                    "$ref": "#/definitions/RequiredAttributes"
                },
                "any_attributes": {
                    "$ref": "#/definitions/AnyAttributes"
                },
                "filter_autocomplete": {
                    "$ref": "#/definitions/FilterAutocomplete"
                }
            }
        },
        "LightdashAdditionalDimension": {
            "type": "object",
            "required": [],
            "properties": {
                "label": {
                    "type": "string"
                },
                "type": {
                    "type": "string",
                    "enum": ["string", "number", "boolean", "date", "timestamp"]
                },
                "description": {
                    "type": "string"
                },
                "sql": {
                    "type": "string"
                },
                "convert_timezone": {
                    "type": "boolean",
                    "description": "When false, this dimension is rendered in its raw warehouse value and is not converted to the project timezone for display. Filter SQL still converts. Defaults to true."
                },
                "timestamp_domain": {
                    "type": "string",
                    "enum": ["aware", "naive"],
                    "description": "Declares whether this timestamp column stores an instant ('aware') or a bare wall clock ('naive'); overrides the warehouse catalog."
                },
                "hidden": {
                    "type": "boolean"
                },
                "round": {
                    "type": "number"
                },
                "compact": {
                    "$ref": "#/definitions/Compact"
                },
                "format": {
                    "$ref": "#/definitions/Format"
                },
                "separator": {
                    "$ref": "#/definitions/Separator"
                },
                "group_label": {
                    "type": "string",
                    "deprecated": true,
                    "description": "Deprecated: use groups instead"
                },
                "urls": {
                    "$ref": "#/definitions/Urls"
                },
                "image": {
                    "$ref": "#/definitions/Image"
                },
                "tags": {
                    "$ref": "#/definitions/Tags"
                },
                "required_attributes": {
                    "$ref": "#/definitions/RequiredAttributes"
                },
                "any_attributes": {
                    "$ref": "#/definitions/AnyAttributes"
                },
                "filter_autocomplete": {
                    "$ref": "#/definitions/FilterAutocomplete"
                }
            }
        },
        "LightdashMetric": {
            "type": "object",
            "required": ["type"],
            "properties": {
                "label": {
                    "type": "string"
                },
                "type": {
                    "type": "string",
                    "enum": [
                        "median",
                        "percentile",
                        "average",
                        "count",
                        "count_distinct",
                        "sum",
                        "sum_distinct",
                        "average_distinct",
                        "min",
                        "max",
                        "number",
                        "string",
                        "date",
                        "boolean",
                        "percent_of_previous",
                        "percent_of_total",
                        "running_total"
                    ]
                },
                "description": {
                    "type": "string"
                },
                "sql": {
                    "type": "string"
                },
                "hidden": {
                    "type": "boolean"
                },
                "round": {
                    "type": "number"
                },
                "compact": {
                    "$ref": "#/definitions/Compact"
                },
                "format": {
                    "$ref": "#/definitions/Format"
                },
                "separator": {
                    "$ref": "#/definitions/Separator"
                },
                "group_label": {
                    "type": "string",
                    "deprecated": true,
                    "description": "Deprecated: use groups instead"
                },
                "urls": {
                    "$ref": "#/definitions/Urls"
                },
                "show_underlying_values": {
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "filters": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "percentile": {
                    "type": "number"
                },
                "distinct_keys": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    ]
                },
                "tags": {
                    "$ref": "#/definitions/Tags"
                },
                "default_time_dimension": {
                    "$ref": "#/definitions/DefaultTimeDimension"
                }
            }
        },
        "LightdashColumnMetadata": {
            "type": "object",
            "required": [],
            "properties": {
                "dimension": {
                    "$ref": "#/definitions/LightdashDimension"
                },
                "additional_dimensions": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/LightdashAdditionalDimension"
                    },
                    "default": {}
                },
                "metrics": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/LightdashMetric"
                    },
                    "default": {}
                }
            }
        },
        "LightdashColumnConfig": {
            "type": "object",
            "properties": {
                "meta": {
                    "oneOf": [
                        {
                            "$ref": "#/definitions/LightdashColumnMetadata"
                        },
                        {
                            "type": "null"
                        }
                    ]
                }
            }
        },
        "LightdashModelMetadata": {
            "type": "object",
            "required": [],
            "properties": {
                "primary_key": {
                    "oneOf": [
                        {
                            "type": "string"
                        },
                        {
                            "type": "array",
                            "items": {
                                "type": "string"
                            }
                        }
                    ]
                },
                "joins": {
                    "type": "array",
                    "items": {
                        "type": "object",
                        "required": ["join", "sql_on"],
                        "properties": {
                            "join": {
                                "type": "string"
                            },
                            "sql_on": {
                                "type": "string"
                            },
                            "type": {
                                "type": "string",
                                "enum": ["inner", "left", "right", "full"]
                            },
                            "always": {
                                "type": "boolean"
                            },
                            "hidden": {
                                "type": "boolean"
                            },
                            "alias": {
                                "type": "string"
                            },
                            "label": {
                                "type": "string"
                            },
                            "fields": {
                                "type": "array",
                                "items": {
                                    "type": "string"
                                }
                            },
                            "relationship": {
                                "type": "string",
                                "enum": [
                                    "one-to-many",
                                    "many-to-one",
                                    "one-to-one",
                                    "many-to-many"
                                ]
                            }
                        }
                    }
                },
                "order_fields_by": {
                    "type": "string",
                    "enum": ["index", "label"]
                },
                "sql_where": {
                    "type": "string"
                },
                "sql_filter": {
                    "type": "string"
                },
                "sql_from": {
                    "type": "string"
                },
                "group_label": {
                    "type": "string",
                    "deprecated": true,
                    "description": "Deprecated: use groups instead"
                },
                "groups": {
                    "type": "array",
                    "description": "Groups are used to group tables in the sidebar. You can create nested groups up to 5 levels. Define labels & descriptions for the group keys in lightdash.config.yml under table_groups.",
                    "items": {
                        "type": "string",
                        "minLength": 1
                    },
                    "maxItems": 5
                },
                "metrics": {
                    "type": "object",
                    "additionalProperties": {
                        "$ref": "#/definitions/LightdashMetric"
                    },
                    "default": {}
                },
                "required_attributes": {
                    "$ref": "#/definitions/RequiredAttributes"
                },
                "any_attributes": {
                    "$ref": "#/definitions/AnyAttributes"
                },
                "default_time_dimension": {
                    "$ref": "#/definitions/DefaultTimeDimension"
                }
            },
            "default": {}
        }
    },
    "$schema": "http://json-schema.org/draft-07/schema#",
    "$id": "https://schemas.lightdash.com/lightdash/metadata.json"
}
